import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TileComponent } from '../tile/tile.component';


@Component({
    selector: 'gbc-collapsible',
    templateUrl: './collapsible.component.html',
    styleUrls: ['./collapsible.component.scss'],
    imports: [TileComponent]
})
export class CollapsibleComponent {
  @Input() title: string;

  @Input() isToggled = false;

  @Output() toggled = new EventEmitter<boolean>();

  onToggle(): void {
    this.isToggled = !this.isToggled;
    this.toggled.emit(this.isToggled);
  }
}
